<template>
  <div>
    <div class="main-content card px-1 pb-1">
      <div class="row p-1 m-0">
        <!-- Filtros -->
        <div class="col-md-12 mb-2">
          <div class="card p-2">
            <div class="row align-items-end m-0">
              <div class="col-md-3">
                <label class="mb-1"><strong>Data Inicial</strong></label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filtros.data_inicio"
                />
              </div>
              <div class="col-md-3">
                <label class="mb-1"><strong>Data Final</strong></label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filtros.data_fim"
                />
              </div>
              <div class="col-md-3">
                <label class="mb-1"><strong>Ação</strong></label>
                <select class="form-control" v-model="filtros.acao">
                  <option value="">Todas</option>
                  <option value="aprovado">Aprovado</option>
                  <option value="rejeitado">Rejeitado</option>
                </select>
              </div>
              <div class="col-md-3">
                <button class="btn btn-primary w-100" @click="getHistorico(1)">
                  <i class="fa fa-search mr-1"></i> Filtrar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabela -->
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-dark">
                <tr>
                  <th>#</th>
                  <th>Data/Hora</th>
                  <th>Pessoa</th>
                  <th>Nome Anterior</th>
                  <th>Nome Solicitado</th>
                  <th>Ação</th>
                  <th>Operador</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td colspan="7" class="text-center py-3">
                    <i class="fa fa-spinner fa-spin mr-1"></i> Carregando...
                  </td>
                </tr>
                <tr v-else-if="!historico.length">
                  <td colspan="7" class="text-center py-3 text-muted">
                    Nenhum registro encontrado.
                  </td>
                </tr>
                <tr v-for="item in historico" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.created_at_f }}</td>
                  <td>{{ item.pessoa_nome }}</td>
                  <td>{{ item.nome_anterior || "-" }}</td>
                  <td>{{ item.nome_novo }}</td>
                  <td>
                    <span
                      class="badge"
                      :class="
                        item.acao === 'aprovado'
                          ? 'badge-success'
                          : 'badge-danger'
                      "
                    >
                      {{
                        item.acao === "aprovado"
                          ? "✅ Aprovado"
                          : "❌ Rejeitado"
                      }}
                    </span>
                  </td>
                  <td>{{ item.operador_nome }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginação -->
          <div
            class="d-flex justify-content-between align-items-center mt-2"
            v-if="pagination.last_page > 1"
          >
            <span class="text-muted">
              Exibindo {{ pagination.from }} a {{ pagination.to }} de
              {{ pagination.total }} registros
            </span>
            <div class="btn-group">
              <button
                class="btn btn-outline-primary btn-sm"
                :disabled="pagination.current_page === 1"
                @click="getHistorico(pagination.current_page - 1)"
              >
                &laquo; Anterior
              </button>
              <button
                class="btn btn-outline-primary btn-sm"
                :disabled="pagination.current_page === pagination.last_page"
                @click="getHistorico(pagination.current_page + 1)"
              >
                Próximo &raquo;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      historico: [],
      loading: false,
      filtros: {
        data_inicio: "",
        data_fim: "",
        acao: "",
      },
      pagination: {
        current_page: 1,
        last_page: 1,
        from: 0,
        to: 0,
        total: 0,
      },
    };
  },
  methods: {
    getHistorico(page = 1) {
      const self = this;
      const api = self.$store.state.api + "historico-edicao-nome";

      self.$loading(true);

      axios
        .get(api, {
          params: {
            page,
            per_page: 25,
            data_inicio: self.filtros.data_inicio || undefined,
            data_fim: self.filtros.data_fim || undefined,
            acao: self.filtros.acao || undefined,
          },
        })
        .then((response) => {
          self.historico = response.data.data;
          self.pagination = {
            current_page: response.data.current_page,
            last_page: response.data.last_page,
            from: response.data.from,
            to: response.data.to,
            total: response.data.total,
          };
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getHistorico();
  },
};
</script>
